export const LogoMark = ({ className = "h-9 w-9", tone = "dark", boxed = false }) => {
  const fg = tone === "light" ? "#F7F7F4" : "#0B1726";
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      {boxed && <rect width="48" height="48" fill={tone === "light" ? "#0B1726" : "#F7F7F4"} />}
      <path d="M12 10h24v5H17v6h19v17H12v-5h19v-7H12z" fill={fg} />
      <rect x="30" y="5" width="6" height="2.5" fill="#C5A46D" />
      <rect x="12" y="40.5" width="24" height="1" fill="#C5A46D" opacity="0.7" />
    </svg>
  );
};

export const Logo = ({ tone = "dark", className = "", testid = "brand-logo" }) => {
  const text = tone === "light" ? "text-paper" : "text-navy";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid={testid}>
      <LogoMark tone={tone} />
      <span className="flex flex-col leading-none">
        <span className={`font-serif text-[22px] font-semibold tracking-[0.28em] ${text}`}>SIDO</span>
        <span className="mt-1 font-sans text-[9px] font-semibold tracking-[0.42em] text-gold">HOLDINGS</span>
      </span>
    </span>
  );
};
